import React from "react";

export default function Offers() {
  return (
    <div
      style={{
        background: "rgb(40,40,40)",
        overflow: "hidden",
      }}
      className="w-100"
    >
      <div className="container-fluid p-0">
        <div className="row g-0">

          {/* LEFT IMAGE */}
          <div className="col-md-6">
              <img
                src="/offer_image.jpeg"
                className="w-100"
                style={{ objectFit: "cover" }}
                alt="Left"
              />
          </div>

          
          <div className="col-md-6">
          
          
           <div className="about-content-offer container">
        <h4 className="text-center">Where craftsmanship meets quiet luxury.</h4>

        <p>
          

        Since 2004, we have redefined premium hotel and healthcare linen through a legacy of precision, innovation, and uncompromising standards. From our headquarters in Canada to our design and fabrication expertise in Washington, United States, and our new manufacturing facility in Saudi Arabia, we deliver world-class textile solutions across the Middle East, Africa, and global markets.
    


        </p>
        <p>
          We curate every collection using the finest materials — from premium 100% cotton to advanced blended fabrics — creating linens that embody elegance, durability, and exceptional comfort.
    Rooted in trust and driven by excellence, we partner with our clients to elevate spaces, enrich guest experiences, and set new standards in hospitality luxury.
        </p>
      </div>
          </div>

        </div>
      </div>
    </div>
  );
}
